var api = "https://api.qingcigame.com";
var MP4_URL = "https://download4.qcplay.com/qcgame-admin/vesMAo7BfvPqjPGVtNxtNeiJYo2Avb3NewVnCG03.mp4";
var TS_URL = "https://download4.qcplay.com/h5-images/active/sakura/pre-registration/output.bin";

function pop(name, isLogin) {
    $("#cover").show();
    $("#" + name).show();
}

function closePop(name) {
    $("#cover").hide();
    $(".submit .btnCover").hide();
    $("#submit,#login").show();
    ischeched = false;

    $("input").val("");
    if (!name) {
        $(".pop").hide();
        return;
    }
    $("#" + name).show();
}

$(function() {
    $("#top .title").append(
        '<a href="https://sakurakaraqgames.onelink.me/hrwt/prepromo" id="btn"></a>',
    );

    $(".monitor-btn").on("click", function() {
        var mon_btn = $(this).attr("data-event");
        countNum(mon_btn);
    });
    // 阿里云埋点
    function countNum(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e);
            }
        }, 500);
    }

    var clientWidth = document.documentElement.clientWidth;
    var clientHeight = document.documentElement.clientHeight;
    if (clientWidth / clientHeight >= 304 / 540) {
        $("#bg").css({
            width: clientWidth + "px",
        });
    } else {
        $("#bg").css({
            width: (clientHeight * 304) / 540 + "px",
        });
    }

    var bg = NiePlayer.create({
        container: "#bg",
        mp4Url: MP4_URL,
        tsUrl: TS_URL,
        videoWidth: clientWidth / clientHeight >= 304 / 540 ?
            clientWidth :
            (clientHeight * 304) / 540,
        loop: true,
        autoplay: true,
        enableAudio: false,
        useTsMode: true,
        tsChuckSize: 1024 * 1024,
        loadTsFirstFrame: true,
    });

    // 当前时间戳
    var newTime = new Date().getTime();
    // 游戏上线时间戳
    var onlineTime = new Date("2026/6/25").getTime();
    if (newTime > onlineTime) {
        $("#btn").remove();
        $("#top .title").append('<a href="javascript:void(0)" id="end_btn"></a>');
    }

    var userAgent = navigator.userAgent;
    var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
        $(".title.slogen2").css({ width: "100%" });
        $(".title.slogen2 .t1").css({ left: "50%", transform: "translateX(-50%)" });
        $(".content-01 .title.slogen2 .down").css({ left: "0.2rem" });
    } else {
        $(".title.slogen2").css({ width: "6.45rem" });
        $(".title.slogen2 .t1").css({ left: "50%", transform: "translateX(-50%)" });
        $(".content-01 .title.slogen2 .down").css({
            left: "-0.2rem",
            bottom: "-0.5rem",
        });
    }

    var isAndroid =
        userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1;
    var isSafari =
        userAgent.indexOf("Safari") !== -1 &&
        userAgent.indexOf("Chrome") === -1 &&
        userAgent.indexOf("Edge") === -1;
    if (isSafari) {
        $(".wrap-03").css({ top: "3%" });
    } else {
        $(".wrap-03").css({ top: "10%" });
    }

    var music = new Howl({
        src: ["/pre-registration/images/music.mp3"],
        autoplay: true,
        loop: true,
        onend: function() {
            //
        },
    });
    music.play();
    var musicCount = 0;
    $(".music").click(function() {
        $(".music").toggleClass("rotate");
        if (musicCount == 0) {
            music.pause();
            musicCount = 1;
            $(".music").css({
                background: "url('/pre-registration/images/mobile/btn1-cb2f9e18ec.png') top no-repeat",
                backgroundSize: "cover",
            });
        } else {
            music.play();
            musicCount = 0;
            $(".music").css({
                background: "url('/pre-registration/images/mobile/btn-d16a5c3536.png') center no-repeat",
                backgroundSize: "cover",
            });
        }
    });

    $("#cover").click(function() {
        closePop();
    });

    // 去X社交群
    $(".to_X").click(function() {
        window.location.href = "https://x.com/ccsakuraomokagi";
    });

    // 去Instagram社交群
    $(".to_instagram").click(function() {
        window.location.href = "https://www.instagram.com/ccsakura_omokagi/";
    });

    // 去line社交群
    $(".to_line").click(function() {
        window.location.href = "https://lin.ee/5tOEM8F";
    });

    // 去TikTok社交群
    $(".to_TikTok").click(function() {
        window.location.href = "https://www.tiktok.com/@ccsakura_omokagi";
    });

    // 去YouTube社交群
    $(".to_YouTube").click(function() {
        window.location.href = "https://www.youtube.com/@ccsakura_omokagi";
    });

    // 去Discord社交群
    $(".to_Discord").click(function() {
        window.location.href = "https://discord.com/invite/bzfg6XEfPK";
    });

    share();

    function share() {
        var share_icon =
            "https://download4.qcplay.com/qcgame-admin/5Voo6wjspOhsom8VFeSWJoi08UZNesGlnkrPbgQt.png";
        var share_big_title = "《庫洛魔法使 回憶鑰匙》手遊預約活動開啟";
        var share_min_title = "快來和我一起籌備上線甜品派對吧~";
        var share_link = window.location.href;
        outside.share(share_icon, share_big_title, share_min_title, share_link);
    }

    // 打开预约奖励活动弹窗
    $(".booking_bonus .btn, .gift2_btn").click(function() {
        pop("booking_bonus_dialog");
    });

    // 关闭预约奖励活动弹窗
    $("#booking_bonus_dialog .close_btn").click(function() {
        closePop();
    });

    // 根据机型去平台
    $(".to_subscribe").click(function() {
        closePop();
        if (isiOS) {
            window.location.href = "https://apps.apple.com/app/id6462015934";
        } else {
            window.location.href =
                "https://play.google.com/store/apps/details?id=com.snell.sakura.ggp.tw";
        }
    });

    // 去服务协议
    $(".footerbg .terms_of_service,#login_dialog .terms_of_service").click(
        function() {
            window.location.href =
                "https://law.snell.com.tw/zh-tw/service_agreement.html";
        },
    );

    // 去隐私协议
    $(".footerbg .privacy_agreement,#login_dialog .privacy_agreement").click(
        function() {
            window.location.href =
                "https://law.snell.com.tw/zh-tw/privacy_policy.html";
        },
    );

    var menuClickCount = 0;
    $(".menu").click(function() {
        if (menuClickCount == 0) {
            $(".nav_list").fadeIn(100);
            menuClickCount = 1;
        } else {
            $(".nav_list").fadeOut(10);
            menuClickCount = 0;
        }
    });

    numInit();

    function numInit() {
        $.ajax({
            url: "//api2.qcplay.com/travel/book/num",
            type: "GET",
            xhrFields: { withCredentials: true },
            data: {
                game_id: 131,
            },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return;
                } else {
                    var book_num = json.data.book_num;
                    $(".content-03 .num span").text(book_num);
                    if (book_num >= 50000 && book_num < 100000) {
                        $(".reach1").show();
                    } else if (book_num >= 100000 && book_num < 200000) {
                        $(".reach1, .reach2").show();
                    } else if (book_num >= 200000 && book_num < 300000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/mobile/third/consummation-ceremony2-5186f91d68.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3").show();
                    } else if (book_num >= 300000 && book_num < 410000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/mobile/third/consummation-ceremony3-06fdef79d0.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3, .reach4").show();
                    } else if (book_num >= 410000 && book_num < 500000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/mobile/third/consummation-ceremony4-3fc850bd19.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3, .reach4, .reach5").show();
                    } else if (book_num >= 500000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/mobile/third/consummation-ceremony5-6acdde1acd.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3, .reach4, .reach5, .reach6").show();
                    }
                }
            },
            complete: function() {
                layer.close();
            },
        });
    }

    //获取查询字符串
    function getQueryString() {
        var queryObj = {};
        var qString = window.location.href.split("?")[1];
        //undefined
        if (!qString) {
            return queryObj;
        }
        qString = qString.indexOf("#") == -1 ? qString : qString.split("#")[0];
        if (!qString) {
            return queryObj;
        }
        var qStringArr = qString.split("&");
        for (var i = 0; i < qStringArr.length; i++) {
            var key = qStringArr[i].split("=")[0];
            var value = qStringArr[i].split("=")[1];
            queryObj[key] = value;
        }
        return queryObj;
    }

    if (cw < 1300) {
        cw = 1300;
    }
    var cw = document.documentElement.clientWidth;
    var loadingW = 0;
    loadingW = Number((8.22 * (cw / 19.2)).toFixed(2));
    var OInner = $(".process-inner");
    var OPercent = $("#percent");
    var timer2;
    var w0 = 0;
    timer2 = setInterval(function() {
        OInner.width((w0 += 30));
        OPercent.text(parseInt((w0 * 100) / loadingW));
        if (parseInt((w0 * 100) / loadingW) >= 100) {
            OPercent.text(100);
            clearInterval(timer2);
        }
        cw = document.documentElement.clientWidth;
        loadingW = (8.22 * (cw / 19.2)).toFixed(2);
        if (w0 >= loadingW) {
            clearInterval(timer2);
            $("#loading").fadeOut(300, function() {
                $("#loading").remove();
            });
        }
    }, 200);

    var swiper = new Swiper(".swiper-container", {
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 0,
        mousewheelControl: true,
        onSlideChangeStart: function(swiper) {
            if (swiper.activeIndex == 0) {
                $(
                    ".content_02_title,.content_03_title,.content_04_title,.content_05_title",
                ).removeClass("width_ani");
            } else if (swiper.activeIndex == 1) {
                $(".content_03_title").addClass("width_ani");
                $(".content_05_title,.content_06_title").removeClass("width_ani");
            } else if (swiper.activeIndex == 2) {
                $(".content_05_title").addClass("width_ani");
                $(".content_03_title,.content_06_title").removeClass("width_ani");
            } else if (swiper.activeIndex == 3) {
                $(".content_06_title").addClass("width_ani");
                $(".content_03_title,.content_05_title").removeClass("width_ani");
            }
        },
    });

    $(".home").click(function() {
        swiper.slideTo(0, 500, true);
        $(".nav_list").fadeOut(10);
        menuClickCount = 0;
    });

    $(".booking-bonus").click(function() {
        swiper.slideTo(1, 500, true);
        $(".nav_list").fadeOut(10);
        menuClickCount = 0;
    });

    $(".characters-intro").click(function() {
        swiper.slideTo(2, 500, true);
        $(".nav_list").fadeOut(10);
        menuClickCount = 0;
    });

    $(".game-features").click(function() {
        swiper.slideTo(3, 500, true);
        $(".nav_list").fadeOut(10);
        menuClickCount = 0;
    });

    indexSwiper();

    // 首页轮播
    function indexSwiper() {
        var cardSwiper = new Swiper(".swiper-container-card", {
            direction: "horizontal",
            loop: true,
            autoplay: 2000, //可选选项，自动滑动
            loop: true,
            pagination: ".swiper-pagination",
            prevButton: "#swiper-button-prev",
            nextButton: "#swiper-button-next",
            paginationClickable: true,
            effect: "coverflow",
            centeredSlides: true,
            slideToClickedSlide: true,
            slidesPerView: "auto",
            coverflow: {
                rotate: 10, // 旋转的角度
                stretch: 100, // 拉伸   图片间左右的间距和密集度
                depth: 140, // 深度   切换图片间上下的间距和密集度
                // modifier: 10, // 修正值 该值越大前面的效果越明显
                slideShadows: false, // 页面阴影效果
            },
            onSlideChangeStart: function(swiper) {},
        });
    }

    if (cw < 1300) cw = 1300;
});